import(/* webpackMode: "eager" */ "/app/landing/src/app/datenschutz/page.tsx");
